import script from "./tab-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./tab-setting-ly.vue?vue&type=style&index=0&id=5afc4c02&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5afc4c02"]])

export default __exports__